export default __webpack_public_path__ + "static/media/pic1.dce23837.jpg";